<script>
import AppLayoutNoAuth from '@/Layout/AppLayoutNoAuth'
export default {
	layout: AppLayoutNoAuth
}
</script>
	
<script setup>
import ThankYou from '@/Pages/Public/MembershipApplication/ThankYou'
</script>

<template>
	<ThankYou />
</template>